const AppraisalOrderContactsCardTestIdsScope = {
  ORDER_CONTACTS: 'order-contacts',
  MANUAL_CONTACT_FORM: 'manual-contact-form',
  CONTACTS_TABLE: 'order-contacts-table',
};

const { ORDER_CONTACTS, MANUAL_CONTACT_FORM, CONTACTS_TABLE } =
  AppraisalOrderContactsCardTestIdsScope;

export const AppraisalOrderContactsCardTestIds = {
  CONTACTS_TABLE: `${ORDER_CONTACTS}.contacts-table`,
  RESET_BUTTON: `${ORDER_CONTACTS}.reset-button`,
  ADD_CONTACT_BUTTON: `${ORDER_CONTACTS}.add-contact-button`,
  getRowId: rowKey => `${CONTACTS_TABLE}.row-${rowKey}`,
  getPrimaryRadioId: rowKey => `${ORDER_CONTACTS}.${rowKey}-primary-radio`,
  getPrimaryLabelId: rowKey => `${ORDER_CONTACTS}.${rowKey}-primary-label`,
  getOrderOnlyLabelId: rowKey => `${ORDER_CONTACTS}.${rowKey}-order-only-label`,
  getDescriptionInputId: rowKey => `${ORDER_CONTACTS}.${rowKey}-description-input`,
  getContactSelectId: rowKey => `${ORDER_CONTACTS}.${rowKey}-contact-select`,
  getContactInputId: rowKey => `${ORDER_CONTACTS}.${rowKey}-contact-input`,
  getActionsButtonId: rowKey => `${ORDER_CONTACTS}.${rowKey}-actions-button`,
  getSetPrimaryButtonId: rowKey => `${ORDER_CONTACTS}.${rowKey}-set-primary-button`,
  getEditButtonId: rowKey => `${ORDER_CONTACTS}.${rowKey}-edit-button`,
  getOpenAgentAndSellerButtonId: rowKey =>
    `${ORDER_CONTACTS}.${rowKey}-open-agent-and-seller-button`,
  getDontSendButtonId: rowKey => `${ORDER_CONTACTS}.${rowKey}-dont-send-button`,
  getRemoveButtonId: rowKey => `${ORDER_CONTACTS}.${rowKey}-remove-button`,
  getAgentAndSellerLinkId: rowKey => `${ORDER_CONTACTS}.${rowKey}-agent-and-seller-link`,
  MANUAL_CONTACT_FORM: `${ORDER_CONTACTS}.manual-contact-form`,
  MANUAL_CONTACT_CANCEL_BUTTON: `${MANUAL_CONTACT_FORM}.cancel-button`,
  MANUAL_CONTACT_SUBMIT_BUTTON: `${MANUAL_CONTACT_FORM}.submit-button`,
  getManualContactInputId: fieldKey => `${MANUAL_CONTACT_FORM}.${fieldKey}-input`,
};
